import { createContext, useContext, useState } from "react";

const CLUBS = [
  { id: "ninersbillard", name: "Ninersbillard", type: "Sportsbar", accent: "#fbbf24", icon: "Home", isBar: true },
  { id: "vip", name: "Niners-VIP Club", type: "Exklusiv", accent: "#d4af37", icon: "Crown" },
  { id: "dsv-niners", name: "DSV Niners Wels", type: "E-Dart", accent: "#06b6d4", icon: "Target", logo: "/assets/lbijdslf_DSV_Niners_Logo.jpg" },
  { id: "sdv-niners", name: "SDV Niners Wels", type: "Steel Dart", accent: "#dc2626", icon: "Crosshair", logo: "/assets/5x7bddw4_SDV_Niners_Logo.jpg" },
  { id: "bsv-niners", name: "BSV Niners Wels", type: "Pool Billard", accent: "#10b981", icon: "Circle" },
  { id: "perchten", name: "D´Wösa Höllen Viecha", type: "Perchten", accent: "#f97316", icon: "Flame" },
  { id: "soundtheatre", name: "The Soundtheatre", type: "Musik/Events", accent: "#8b5cf6", icon: "Music" },
  { id: "sportuebertragungen", name: "Sportübertragungen", type: "30m² Leinwand & 8 Screens", accent: "#ef4444", icon: "Tv", isSpecial: true },
  { id: "shop", name: "Niners-Shop", type: "Dart & Billard Zubehör", accent: "#a855f7", icon: "ShoppingBag", isSpecial: true },
];

const ClubContext = createContext();

export function ClubProvider({ children }) {
  const [activeClub, setActiveClub] = useState(null);

  const getClubAccent = (clubId) => {
    const club = CLUBS.find(c => c.id === clubId);
    return club ? club.accent : "#fbbf24";
  };

  const getClubName = (clubId) => {
    const club = CLUBS.find(c => c.id === clubId);
    return club ? club.name : "";
  };

  return (
    <ClubContext.Provider value={{ activeClub, setActiveClub, clubs: CLUBS, getClubAccent, getClubName }}>
      {children}
    </ClubContext.Provider>
  );
}

export function useClub() {
  const context = useContext(ClubContext);
  if (!context) throw new Error("useClub must be used within ClubProvider");
  return context;
}
